import {
  CookiesConsent,
  manageGoogleAnalytics,
  manageGoogleTagManager,
} from '@metamorfosilab/cookies-consent';

// const siteUrl = window.location.origin;
const cookieNoticeUrl = site_url + 'cookie-policy';

const cookiesConsent = new CookiesConsent({
  expirationDays: 182, // half year
  buttons: ['accept', 'settings', 'reject'],

  content: {
    btnAccept: 'Прийняти все',
    btnReject: 'Відмовитися від усього',
    btnSettings: 'Налаштувати параметри',
    btnSettingsSelectAll: 'Прийняти все',
    btnSettingsAccept: 'Прийняти вибране',
    title: 'Цей веб-сайт використовує Cookies!',
    message: `
        
      <p>
        Цей веб-сайт використовує файли cookie для аналізу трафіку та покращення вашого користувацького досвіду. Натискаючи 'Прийняти все', ви погоджуєтеся на використання всіх файлів cookie. Ви можете налаштувати свої вподобання або відмовитися від усіх файлів cookie, натиснувши 'Налаштування файлів cookie' або 'Відхилити все' відповідно. Для отримання детальної інформації ознайомтеся з нашою <a href=${cookieNoticeUrl}>Політикою використання файлів cookie</a>.
      </p>
      `,
    // policy: 'Privacy Policy',
    // policyLink: 'https://gdpr-info.eu/',
    settingsFooter: `
    <p>
      Однак, якщо ви налаштуєте ваш браузер на блокування всіх файлів cookie, включаючи необхідні, ви можете не мати доступу до всіх або деяких функцій нашого веб-сайту. Зверніть увагу, що всі файли cookie, за винятком необхідних, втрачають свою дію після закінчення терміну, вказаного в нашій <a href=${cookieNoticeUrl}>Політиці використання файлів cookie</a>.
    </p>
  `,
  },

  cookies: [
    {
      name: 'title_cookie',
      title: 'Додаткові налаштування',
      checked: true,
    },
    {
      checked: true,
      name: 'essential_cookie',
      title: 'Основні види Cookies',
      description: `
      <p>
        Ці файли cookie необхідні для забезпечення основної функціональності Сайту. Без цих файлів cookie запитувані вами послуги не можуть бути надані. Якщо ви вимкнете ці файли cookie, певні частини Сайту не працюватимуть для вас.
      </p>
      `,
    },
    {
      name: 'analytics_cookie',
      title: 'Аналітичні файли Cookies',
      description: `
      <p>
        Ці файли cookie використовуються для збору інформації про те, як відвідувачі взаємодіють із нашим Сайтом. Вони допомагають нам зрозуміти, які сторінки є найбільш популярними, скільки часу користувачі проводять на Сайті, а також виявити можливі проблеми в роботі ресурсу. Це дозволяє нам покращувати контент і функціональність Сайту, забезпечуючи кращий користувацький досвід. Наприклад, ми можемо аналізувати кількість відвідувань певних сторінок або оцінювати ефективність наших маркетингових кампаній.
      </p>
      `,
      cookies: [
        {
          name: 'cc_ga',
          code: 'G-5VB9Y83CYB',
          manageFunction: manageGoogleAnalytics,
        },
        {
          name: 'cc_gtm',
          code: 'GTM-PVJH7S4',
          manageFunction: manageGoogleTagManager,
        },
      ],
    },
  ],
});

const cookiesConsentSetting = function(option) {
  const elem = (option === 'sets' && '.js-cookie-setting') || (option === 'msn' && '.js-cookie-msn')
  const settingTriggers = document.querySelectorAll(elem);

  settingTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      option === 'sets' && cookiesConsent.toggleSettings();
      option === 'msn' && cookiesConsent.showMessage();
    })
  })
}
window.cookiesConsent = cookiesConsent;

window.cookiesConsentSetting = cookiesConsentSetting('sets');
window.cookiesConsentShow = cookiesConsentSetting('msn');
